const heroHeaderImageToggleItem = () => {
    const images = document.querySelectorAll('.hero-header__image');

    for (const image of images) {
        image.classList.toggle('is--active');
    }
};

const heroHeaderImageToggle = () => {
    const imageWrapper = document.querySelector('.hero-header__image-wrapper');
    imageWrapper.addEventListener('mouseenter', heroHeaderImageToggleItem, false);
    imageWrapper.addEventListener('mouseout', heroHeaderImageToggleItem, false);
};

window.addEventListener('DOMContentLoaded', () => {
    heroHeaderImageToggle();
});
